export default __webpack_public_path__ + "2aa04ea3e73fc44632fe35e1d4b59480.webp";